import { useState } from "react";
import { Fan, BatteryCharging, Droplets, Package, Radar, Container, Joystick, Map, ArrowUpRight } from "lucide-react";
import { REPUESTOS, track } from "@/data/content";
import { Reveal, SectionTag, TituloLineas } from "@/components/Reveal";
import Desplegable from "@/components/Desplegable";
import { useCertero } from "@/context/CerteroContext";

const ICONS = {
  fan: Fan, battery: BatteryCharging, droplets: Droplets, package: Package,
  radar: Radar, container: Container, joystick: Joystick, map: Map,
};

export default function Repuestos() {
  const { openLead } = useCertero();
  const [abierto, setAbierto] = useState(null); // una sola tarjeta abierta por vez

  return (
    <section id="repuestos" className="scroll-mt-20 border-y border-hud bg-ink px-4 py-14 sm:px-8 sm:py-20 lg:px-12 lg:py-32">
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <SectionTag>Repuestos y accesorios</SectionTag>
          <TituloLineas
            lineas={["Originales DJI, listos", "cuando su operación los necesita"]}
            className="mt-5 max-w-2xl font-display text-2xl font-bold uppercase leading-tight tracking-tight text-mist sm:text-3xl lg:text-4xl"
          />
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-smoke sm:text-base">
            Para toda la línea Agras y el Mavic 3M. Toque un repuesto y consulte.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-4 sm:gap-5 lg:grid-cols-4">
          {REPUESTOS.map((r, i) => {
            const Icon = ICONS[r.icon];
            return (
              <Reveal key={r.id} delay={Math.min(0.3, i * 0.05)}>
                <Desplegable
                  id={r.id}
                  titulo={r.t}
                  icono={Icon}
                  abierto={abierto === r.id}
                  onToggle={(id) => setAbierto((a) => (a === id ? null : id))}
                  testid={`repuesto-desplegable-${r.id}`}
                >
                  <p className="flex-1 text-sm leading-relaxed text-smoke">{r.d}</p>
                  <button
                    data-testid={`repuesto-btn-consultar-${r.id}`}
                    onClick={() => { track("consultar_repuesto_click", { repuesto: r.t }); openLead("repuesto", r.t); }}
                    className="mt-6 inline-flex items-center gap-2 self-start font-display text-xs font-bold uppercase tracking-[0.15em] text-certero transition-colors duration-300 hover:text-[#4bc443]"
                  >
                    Consultar repuesto <ArrowUpRight className="h-3.5 w-3.5" />
                  </button>
                </Desplegable>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.2em] text-smoke/70">
            ¿No encuentra la pieza? Escríbanos por WhatsApp con el modelo de su dron y la buscamos.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
